export const SETTINGS = {
    FILTERS_DEFAULT_TIMEFRAME: 7,
    INTERNATIONAL_SOS_SEVERITIES: {
        'Notice': true,
        'Advisory': true,
        'Special Advisory': true,
        'Warning': true,
        'Stand By': true,
        'Evacuate (non essential staff)': true,
        'Evacuate (Full Evacuation)': true
    }
}
